import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   globalVideo: null,
};

const setGlobalVideo= (state: any, action: any) => {
   state.globalVideo = action.payload;
};



export const globalSlice = createSlice({
   name: 'global',
   initialState,
   reducers: {
      setGlobalVideo
   },
});

export default globalSlice;
